<template>
  <div style="margin: 0 auto; width: 10px;">
    <div class="loader-dark-blue medium mb-5 mt-5"/>
  </div>
</template>
<script>
export default {
  name: 'Spinner'
}
</script>
